// FROM: https://github.com/modusign/modusign-client/blob/b6c3d577fdd8384ea2f73c5ab605ead1afc782d1/app/src/libs/formatter/formatMeans.ts

import { SigningMethod } from '@modusign/react-signing/types';
import isEmail from 'validator/lib/isEmail';

import { getFormattedSouthKoreaPhoneNumber } from '@app/libs/inputFormat';

export function formatContact(signingMethod?: SigningMethod | null, contact?: string | null) {
  if (!contact || !signingMethod) return null;

  switch (signingMethod) {
    case 'KAKAO':
    case 'IN_PERSON':
    case 'SECURE_LINK':
      return isEmail(contact) ? contact : getFormattedSouthKoreaPhoneNumber(contact);
    default:
      return contact;
  }
}
